/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const pitchDeckRejectionDtoSchema = z.object({
  layer: z.optional(z.string()),
  code: z.optional(z.string()),
  description: z.optional(z.string()),
});
